import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class UiService {
  private loading = false;
  private saving = false;
  private labelsMap: Map<string, string>;

  constructor() {
    this.labelsMap = new Map<string, string>([
      ['SIMPLE_DOCX', 'Simple Word'],
      ['SIMPLE_DOCX_S3_SAVE', 'Simple Word'],
    ]);
  }

  isLoading(): boolean {
    return this.loading;
  }

  load(): void {
    this.loading = true;
  }

  loaded(): void {
    this.loading = false;
  }

  isSaving(): boolean {
    return this.saving;
  }

  save(): void {
    this.saving = true;
  }

  saved(): void {
    this.saving = false;
  }

  getFrontendLabel(backendValue: any) {
    return this.labelsMap.get(backendValue) ?? null;
  }
}
